import { CompleteUserData, Infractions, InfractionsFromBack } from '@/interfaces/my-profile/my-profile';
import { parseISOString } from '@/utils/parseISOString';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CacheService } from '@/utils/cacheService/cache.service';

@Injectable({
  providedIn: 'root',
})
export class MyProfileService {

  constructor(
    private http: HttpClient,
    private cacheService: CacheService,
  ) { }

  // Person data should not change
  getFullUserData(userId: string): Observable<CompleteUserData> {
    const source$ = this.http.get<CompleteUserData>(`MyProfile/UserInfo?userId=${userId}`);
    return this.cacheService.save<CompleteUserData>(`getFullUserData${userId}`, 24 * 60, source$);
  }

  getInfractions(userId: string): Observable<Infractions[]> {
    return this.http.get<InfractionsFromBack[]>(`MyProfile/InfringementsByUser?userId=${userId}`)
      .pipe(map((infractions) => infractions.map((infraction) => {
        const date = parseISOString(infraction.infringementDate, true);

        // fixed hour by hour zone
        date.setHours(date?.getHours() + (date.getTimezoneOffset() / 60));

        let defaultHours = `${date?.getHours()}`;
        if (defaultHours.length === 1) defaultHours = `0${defaultHours}`;

        let defaultMinutes = `${date?.getMinutes()}`;
        if (defaultMinutes.length === 1) defaultMinutes = `0${defaultMinutes}`;

        return {
          ...infraction,
          evidences: infraction.evidences.map(({ description }) => description),
          infringementDate: date,
          infringementHour: `${defaultHours}:${defaultMinutes}`,
        };
      })));
  }
}
